import {fetchTrendingLands} from '#/repository/fetch-trending-lands';
import {useQuery} from '@tanstack/react-query';

export const useTrendingLands = () => useQuery({queryKey: ['lands-trending'], queryFn: fetchTrendingLands});
